import type { ResourceExtension } from './adminContext';
import type { ResourceDef } from './resources';

/** A form with at least this many fields opens on its own page; smaller ones stay in a dialog (DESIGN_SYSTEM.md). */
export const FORM_PAGE_MIN_FIELDS = 10;

/**
 * Whether a resource is created and edited on its own page instead of a dialog: what its extension says (`formPage`), else
 * when the form is large: many fields, an address, or a field with its own editor (a rule builder, for example).
 */
export function usesFormPage(def: ResourceDef, extension?: ResourceExtension): boolean {
  if (extension?.formPage !== undefined) return extension.formPage;
  const shown = def.fields.filter((f) => !f.hidden);
  return (
    shown.length >= FORM_PAGE_MIN_FIELDS ||
    Boolean(def.address) ||
    shown.some((f) => extension?.fieldEditors?.[f.key] !== undefined)
  );
}
